import MyCardDetails from '../views/MyCardDetails';
import NewMyCard from '../views/NewMyCard';
import MyCards from '../views/MyCards';

const router = [
  {
    name: 'myCards',
    path: '/my-cards',
    component: MyCards,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'myCardDetails',
    path: '/my-cards/:card_id',
    component: MyCardDetails,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'newMyCard',
    path: '/new-my-card',
    component: NewMyCard,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/app/my-cards/router/index.js